export var buildAdminMentionableUsers = function (adminUsers) {
    return adminUsers.map(function (adminUser) { return ({
        id: adminUser.id,
        fullName: (adminUser.first_name + " " + adminUser.last_name).trim(),
        mentionType: 'admin',
    }); });
};
